export const state = () => ({})

export const mutations = {}

export const actions = {
  async nuxtServerInit({ dispatch }) {
    try {
      // Пытаемся обновить токен и получить данные пользователя
      // await dispatch('auth/refreshToken')
      await dispatch('auth/loadAuthData')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Ошибка при обновлении токена:', error)
      // Здесь можно добавить логику для обработки ошибок, например, перенаправление на страницу входа
    }
  },
}
